import { render } from "./Page.vue?vue&type=template&id=4339eed7&scoped=true"
import script from "./Page.js?vue&type=script&lang=js"
export * from "./Page.js?vue&type=script&lang=js"

import "./Page.scss?vue&type=style&index=0&id=4339eed7&lang=scss&scoped=true"

import exportComponent from "/Users/jiangxin/xhw/outer-h5-gwj-nft-website-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4339eed7"]])

export default __exports__